import axios from "axios";
import { base, insuranceUrl, websocketServiceUrl } from "../constants";
import {
  LoginDetailsType,
  LoginResponseType,
} from "../Types/Authentication/LoginTypes";
import { ResponseType } from "../Types/ServicesType/servicesType";
import {
  getItem,
  setItem,
  storageKey,
} from "../utilis/methods/storage/storage";
import { UserPermissionType } from "../Types/Authentication/AuthenticationTypes";
import api from "@services/apiList";
import globalRouter from "@routes/globalRoute";
import PageRouterList from "@routes/routeList";
const baseURL =
  import.meta.env.MODE == "production"
    ? `${insuranceUrl.startsWith("/") ? location.protocol + "//" + location.host + (window as any)._env_?.VITE_API_URL : insuranceUrl}`
    : `${location.protocol + "//" + location.host}`;
// export const oldInstance = inst
export const errorResponse: ResponseType<any> = {
  response: null,
  responseIndicator: "fail",
  responseMessage: "Something went wrong !",
  statusCode: "400",
};

const instance = axios.create({
  baseURL: baseURL,
});

const refreshInstance = axios.create({
  baseURL: baseURL,
});

export const tokenServices = async (
  token: string,
): Promise<ResponseType<{ accessToken: string }>> => {
  const result = await refreshInstance.get(
    `${baseURL}${api.authentication.tokenVerify}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const tokenData = result.data;
  return { ...tokenData };
};

instance.interceptors.request.use(
  (config) => {
    const token = getItem(storageKey.TOKEN);
    const user = getItem(storageKey.USER);
    if (token) {
      config.headers.Authorization = `Bearer ${token?.accessToken}`;
    }
    if (user?.tenantClinicId) {
      config.headers["X-TenantId"] = user.tenantClinicId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let isRefreshing = false;
let failedQueue: any[] = [];
let notfoundCount = 0;

const isWebSocketServiceRequest = (requestUrl?: string) => {
  if (!requestUrl) return false;
  const wsPath = websocketServiceUrl || "/web-socket-service";
  return requestUrl.includes(wsPath);
};

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const redirectToLogin = () => {
  localStorage.clear();
  sessionStorage.clear();

  // avoid infinite loop
  delete instance.defaults.headers.common["Authorization"];
  delete instance.defaults.headers.common["X-TenantId"];
  globalRouter.navigate(`${base}${PageRouterList.expired}`);
};

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 404) {
      const requestUrl = String(originalRequest?.url || "");
      if (!isWebSocketServiceRequest(requestUrl)) {
        notfoundCount++;
        if (notfoundCount > 10) {
          window.location.reload();
        }
      }
    }
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token: string) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(instance(originalRequest));
            },
            reject: (err: any) => reject(err),
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const details = getItem(storageKey.USER) as LoginResponseType;

        if (!details?.refreshtoken) {
          redirectToLogin();
          return Promise.reject(error);
        }

        const { response } = await tokenServices(details.refreshtoken);

        setItem(storageKey.TOKEN, response);
        setItem(storageKey.accessToken, response.accessToken);

        instance.defaults.headers.common["Authorization"] =
          `Bearer ${response.accessToken}`;

        details?.clinicId &&
          (instance.defaults.headers.common["X-TenantId"] = Number(
            details.clinicId,
          ));

        processQueue(null, response.accessToken);
        return instance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        redirectToLogin();
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

//authentication services

export const loginServices = async (
  body: LoginDetailsType,
): Promise<
  ResponseType<{
    user: LoginResponseType;
    message: string;
    status: boolean;
    photo: string;
  }>
> => {
  const result = await instance.post(api.authentication.login, body);
  return result.data;
};

export const logoutServices = async (
  token: string,
): Promise<
  ResponseType<{
    user: LoginResponseType;
    message: string;
    status: boolean;
    photo: string;
  }>
> => {
  const result = await instance.post(
    `${api.authentication.logout}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return result.data;
};

export const getPivilegesServices = async (): Promise<
  ResponseType<{ permissions: UserPermissionType }>
> => {
  const data = getItem(storageKey.USER) as LoginResponseType;
  const result = await instance.post(api.authentication.getPrivilage, {
    clinicId: data.clinicId,
    userId: data.login_id,
  });
  return result.data;
};

export const getNotification = async (): Promise<
  ResponseType<{ procedures: string[]; verifications: string[] }>
> => {
  const user = getItem(storageKey.USER) as LoginResponseType | null;

  const result = await instance.get(
    `${api.notification.all}${user?.clinicId}?userType=${user?.groupId}`,
  );
  return result.data;
};

export default instance;

// import axios from "axios";

// import { baseURL, insuranceUrl } from "../constants";
// import {
//   LoginDetailsType,
//   LoginResponseType,
// } from "../Types/Authentication/LoginTypes";
// import { ResponseType } from "../Types/ServicesType/servicesType";
// import {
//   getItem,
//   setItem,
//   storageKey,
// } from "../utilis/methods/storage/storage";
// import { UserPermissionType } from "../Types/Authentication/AuthenticationTypes";
// import api from "@services/apiList";
// import { normalizeDates } from "@utilifiles/component/NormalizeDate";

// // ---------------------------
// // Base Instances
// // ---------------------------
// const inst = axios.create({ baseURL });
// export const oldInstance = inst;

// // ---------------------------
// // Default error response
// // ---------------------------
// export const errorResponse: ResponseType<any> = {
//   response: null,
//   responseIndicator: "fail",
//   responseMessage: "Something went wrong !",
//   statusCode: "400",
// };

// // ---------------------------
// // Token Services
// // ---------------------------
// export const tokenServices = async (
//   token: string
// ): Promise<ResponseType<{ accessToken: string }>> => {
//   const result = await axios.get(
//     `${insuranceUrl}${api.authentication.tokenVerify}`,
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
//   const tokenData = result.data;
//   return { ...tokenData };
// };

// // ---------------------------
// // Main Axios Instance
// // ---------------------------
// const instance = axios.create({
//   baseURL: insuranceUrl,
// });

// // ---------------------------
// // Request Interceptor
// // ---------------------------
// instance.interceptors.request.use(
//   (config) => {
//     const token = getItem(storageKey.TOKEN);
//     if (token) {
//       config.headers.Authorization = `Bearer ${token?.accessToken}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ---------------------------
// // Token Refresh Logic
// // ---------------------------
// let isRefreshing = false;
// let failedQueue: any[] = [];

// const processQueue = (error: any, token: string | null = null) => {
//   failedQueue.forEach((prom) => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });
//   failedQueue = [];
// };

// // ---------------------------
// // Response Interceptor
// // ---------------------------
// instance.interceptors.response.use(
//   (response) => {
//     try {
//       // ✅ Read latest theme config from localStorage (saved by ThemeProvider)
//       const storedTheme = localStorage.getItem("customTheme");
//       const customTheme = storedTheme
//         ? JSON.parse(storedTheme)
//         : { dateFormat: "DD-MM-YYYY" };

//       // ✅ Recursively normalize all date strings
//       response.data = normalizeDates(response.data, customTheme.dateFormat);
//     } catch (e) {
//       console.warn("Date normalization failed:", e);
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     if (
//       (error.response?.status === 401 || error.response?.status === 403) &&
//       !originalRequest._retry
//     ) {
//       if (isRefreshing) {
//         return new Promise(function (resolve, reject) {
//           failedQueue.push({
//             resolve: (token: string) => {
//               originalRequest.headers.Authorization = `Bearer ${token}`;
//               resolve(instance(originalRequest));
//             },
//             reject: (err: any) => reject(err),
//           });
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const details = getItem(storageKey.USER) as LoginResponseType;
//         const { response } = await tokenServices(details.refreshtoken);

//         setItem(storageKey.TOKEN, response);
//         setItem(storageKey.accessToken, response.accessToken);
//         instance.defaults.headers.common[
//           "Authorization"
//         ] = `Bearer ${response.accessToken}`;
//         processQueue(null, response.accessToken);

//         return instance(originalRequest);
//       } catch (err) {
//         processQueue(err, null);
//         return Promise.reject(err);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// // ---------------------------
// // Authentication Services
// // ---------------------------
// export const loginServices = async (
//   body: LoginDetailsType
// ): Promise<
//   ResponseType<{
//     user: LoginResponseType;
//     message: string;
//     status: boolean;
//     photo: string;
//   }>
// > => {
//   const result = await axios.post(
//     insuranceUrl + api.authentication.login,
//     body
//   );
//   return result.data;
// };

// export const logoutServices = async (
//   token: string
// ): Promise<
//   ResponseType<{
//     user: LoginResponseType;
//     message: string;
//     status: boolean;
//     photo: string;
//   }>
// > => {
//   const result = await axios.post(
//     `${insuranceUrl}${api.authentication.logout}`,
//     {},
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
//   return result.data;
// };

// export const getPivilegesServices = async (): Promise<
//   ResponseType<{ permissions: UserPermissionType }>
// > => {
//   const data = getItem(storageKey.USER) as LoginResponseType;
//   const result = await instance.post(api.authentication.getPrivilage, {
//     clinicId: data.clinicId,
//     userId: data.login_id,
//   });
//   return result.data;
// };

// export const getNotification = async (): Promise<
//   ResponseType<{ procedures: string[]; verifications: string[] }>
// > => {
//   const user = getItem(storageKey.USER) as LoginResponseType | null;
//   const result = await instance.get(
//     `${api.notification.all}${user?.clinicId}?userType=${user?.groupId}`
//   );
//   return result.data;
// };

// export default instance;
